import axios from "axios";
import { clearUserData } from "../redux/reducers/userReducer";
import { clearSchoolData } from "../redux/reducers/schoolReducer";
import { clearDashboardData } from "../redux/reducers/dashboardReducer";
import { clearLoadingData } from "../redux/reducers/loadingReducer";
import { watchForMaintenance } from "./maintenance";

var totalRequest = 0;
// Create an Axios instance
const axiosInstance = axios.create({
     //   baseURL: "https://api.example.com", // Replace with your API base URL
     timeout: 10000,
});
// Platform update in progress → maintenance page (see utils/maintenance.js)
watchForMaintenance(axiosInstance);

// Request Interceptor
axiosInstance.interceptors.request.use(
     (config) => {
          totalRequest++;
          // console.log("request-1", totalRequest);
          // Add authorization token if available
          const userToken = localStorage.getItem("userToken");
          const token = userToken ? JSON.parse(userToken) : userToken;
          // console.log("axiosInstance token", token);

          if (token) {
               // config.headers.Authorization = `Bearer ${token}`;
               config.headers["Accept"] = "application/json";
               config.headers["Content-Type"] = "application/json";
               config.headers["x-access-token"] = token;
          }
          return config;
     },
     (error) => {
          // totalRequest--;
          // console.log("request-2", totalRequest);
          return Promise.reject(error);
     }
);


export const setupInterceptors = (store) => {
     // Response Interceptor
     axiosInstance.interceptors.response.use(
          (response) => {
               // totalRequest--;
               totalRequest = Math.max(totalRequest - 1, 0);
               // console.log("response-1", totalRequest);

               // spinning hide
               if (totalRequest === 0) {
                    store.dispatch(clearLoadingData());
               }
               // console.log("setupInterceptors response.data.statusCode", response.data.statusCode);

               if (response.data.statusCode === 403 && typeof response.data.message == "object" && response.data.message.name === "TokenExpiredError") {
                    // console.log("interceptors response: ", "logout");
                    localStorage.removeItem("userToken");
                    localStorage.removeItem("persist:root");
                    store.dispatch(clearUserData());
                    store.dispatch(clearSchoolData());
                    store.dispatch(clearDashboardData());
                    // await setUserToken("");
                    // navigate("/", { replace: true });
                    window.location.href = "/";
               }
               return response;
          }, // Return response normally
          (error) => {
               // totalRequest--;
               totalRequest = Math.max(totalRequest - 1, 0);
               if (totalRequest === 0) {
                    store.dispatch(clearLoadingData());
               }
               // console.log("response-2", totalRequest);
               if (!error.response) {
                    // Network error, server down, or timeout
                    console.warn("Network error:", error.message);

                    // Dispatch an action to show error in UI
                    // store.dispatch(showErrorNotification("Network issue. Please try again later."));
               } else {
                    const { status } = error.response;

                    // 401 only. A 502 means the API server is down or restarting (e.g. during a deploy), not that the
                    // session is invalid; logging everyone out on 502 signed all users out on every deploy.
                    if (status === 401) {
                         console.log("interceptors error.status: ", status);
                         // console.error("Unauthorized! Logging out... 401");
                         localStorage.removeItem("userToken");
                         localStorage.removeItem("persist:root");
                         store.dispatch(clearUserData());
                         store.dispatch(clearSchoolData());
                         store.dispatch(clearDashboardData());
                         //    await setUserToken("");
                         window.location.href = "/";
                         // console.error("Bad Gateway (502): Server might be down.");
                    }
               }
               return Promise.reject(error);
          }
     );
};

export default axiosInstance;
